import { useTranslation } from "react-i18next";
import { BaseItemDialog } from "@/components/shared/BaseItemDialog";
import type { CustomPart } from "@onsemble/shared";

interface CustomPartDialogProps {
  isOpen: boolean;
  onClose: () => void;
  mode: "add" | "edit";
  customPart?: CustomPart;
  orgId: string;
  onCustomPartAdded?: (customPartId: string, customPart?: CustomPart) => void;
  onCustomPartUpdated?: (customPart: CustomPart) => void;
}

export const CustomPartDialog: React.FC<CustomPartDialogProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BaseItemDialog<CustomPart>
      {...props}
      item={props.customPart}
      apiEndpoint="/api/custom-parts"
      queryKey="/api/custom-parts"
      itemType="custom part"
      itemTypeCapitalized={t("components.customParts.customPartDialog.customPart")}
      showDescription={false}
      onItemAdded={props.onCustomPartAdded}
      onItemUpdated={props.onCustomPartUpdated}
    />
  );
};
